import propTypes from 'prop-types'
import {Box, Icon} from '@chakra-ui/react'

const PrimaryCurrentStep = ({title, icon, number}) => (
  <Box display="flex" alignItems="center">
    <Box>Step</Box>
    <Box
      width="25px"
      height="25px"
      flexShrink={0}
      borderRadius="full"
      textStyle="body-small"
      lineHeight="25px"
      margin="0 4px 0 4px"
      color="mld.neutral.1000"
      backgroundColor="mld.neutral.200"
      textAlign="center"
    >
      {number}
    </Box>
    <Box display="flex" alignItems="center" justifyContent="center">
      {icon && <Icon as={icon} marginRight="4px" />}
      {title}
    </Box>
  </Box>
)

PrimaryCurrentStep.defaultProps = {
  icon: null,
}

PrimaryCurrentStep.propTypes = {
  title: propTypes.string.isRequired,
  icon: propTypes.func,
  number: propTypes.number.isRequired,
}

export default PrimaryCurrentStep
